<template>
	<label class="fd-cat-label" :style="extraStyle">
		<input v-if="typeof cat.sel === 'boolean' ? cat.sel : true" type="checkbox" v-model="state" class="fd-checkbox" :disabled="cat.dis || disabled">
		<sym-icon v-if="cat.icon" :name="cat.icon"></sym-icon>
		<span>{{ cat.title }}</span>
	</label>
</template>

<script setup lang="ts">
import SymIcon from "../../helpers/SymIcon.vue";
import {computed, type CSSProperties, ref, watch} from "vue";

const props = defineProps({
	cat: {
		type: Object,
		required: true
	},
	level: {type: Number, default: 0},
	value: {
		type: Boolean
	},
	noremove: Boolean,
	noadd: Boolean
});
const emit = defineEmits(["change"]);

const state = ref<boolean>(props.value);

const extraStyle = computed(() => {
	const s: CSSProperties = {};
	if (props.cat.level > 0) s.marginLeft = (props.cat.level * 8) + "px";
	return s;
});

const disabled = computed(() => {
	if (props.noremove && state.value) return true;
	if (props.noadd && !state.value) return true;
	return false;
});

watch(() => state.value, (n: boolean) => {
	emit("change", {
		id: props.cat.id,
		state: n
	});
});
watch(() => props.value, (n: boolean) => {
	state.value = n;
});
</script>

<style>
.fd-cat-label {
	display: flex;
	align-items: baseline;
	column-gap: 4px;
	line-height: var(--input-height);
	white-space: nowrap;
}
</style>